import { render, staticRenderFns } from "./clientProfileWorkflowTypes.vue?vue&type=template&id=fafcb664&scoped=true"
import script from "./clientProfileWorkflowTypes.vue?vue&type=script&lang=js"
export * from "./clientProfileWorkflowTypes.vue?vue&type=script&lang=js"
import style0 from "./clientProfileWorkflowTypes.vue?vue&type=style&index=0&id=fafcb664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafcb664",
  null
  
)

export default component.exports